export default "__VITE_ASSET__nlm5yQKS__"